import { SignUpForm } from 'components/Forms/Auth/SignUp';
import { AuthLayout } from 'components/Layout/Auth';
import { addApolloState, initializeApollo } from 'lib/clients/apolloClient';
import { GLOBAL } from 'queries';

const SignUp = () => {
  return <SignUpForm />;
};

export async function getStaticProps() {
  const apolloClient = initializeApollo();

  await Promise.all([
    apolloClient.query({
      query: GLOBAL,
    }),
  ]);

  return addApolloState(apolloClient, {
    props: {},
    revalidate: 60 * 5,
  });
}

SignUp.Layout = AuthLayout;

export default SignUp;
